<script>
	module.exports = {
		props: {
			options: {
				default: []
			},
			onOptionToggle: {
				default: function () {}
			},
			loading: {
				default: false
			},
			disabled: {
				default: false
			}
		},
		data() {
			return {
				showTray: false
			};
		},
		computed: {
			label() {
				let options = this.options;
				let selectedOptions = options.filter(o => o.selected);
				let text = 'None Selected';

				if (selectedOptions.length > 1) {
					text = selectedOptions.length + ' Selected';
				} else if (selectedOptions.length === 1) {
					text = selectedOptions[0].text;
				}
				return text;
			},
			tooltip() {
				let options = this.options;
				let selectedOptions = options.filter(o => o.selected);
				let tooltipLabel = null;

				if (selectedOptions.length > 1) {
					tooltipLabel = selectedOptions.map(o => o.text).join(', ');
				}

				return tooltipLabel;
			}
		},
		beforeDestroy() {
			$(document).off('click', this.onOutsideClick);
		},
		methods: {
			toggleTray() {
				this.showTray = !this.showTray;
				if (this.showTray) {
					$(document).on('click', this.onOutsideClick);
				}
			},
			onOutsideClick(e) {
				if (!$(this.$el).has(e.target).length) {
					this.showTray = false;
					$(document).off('click', this.onOutsideClick);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.validated-multiselect {
		position: relative;
		margin: 1rem 0;

		.multiselect-options {
			display: none;
			position: absolute;
			max-height: 12rem;
			overflow: auto;
			top: 100%;
			z-index: 2;
			padding: 1rem;
			background-color: white;
			border-width: 1px;
			border-color: $c-grey;
			border-style: solid;
			width: 100%;
			border-radius: 0 0 4px 4px;
			box-shadow: 0px 3px 3px $c-grey;

			label {
				display: flex;
				align-items: center;
				padding-bottom: 0.5rem;
				border-bottom: 2px solid $c-grey;

				.option-text {
					flex: 1;
					padding-left: 0.5rem;
				}
			}
		}

		&.show-tray .multiselect-options {
			display: inherit;
		}

		.load-mask {
			display: none;
			position: absolute;
			z-index: 4;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background: white;
			opacity: 0.7;

			&:after {
				position: absolute;
				display: inline-block;
				top: 40%;
				right: 50%;
				content: ' ';
				margin-left: 0.2em;
				width: 1em;
				height: 1em;
				background-image: url('/assets/dist/images/loader.gif');
				background-size: 100%;
				opacity: 1;
			}

			&.loading {
				display: inherit;
			}
		}
	}
</style>
<template>
	<div
		class="validated-multiselect validated-input touched"
		:class="{
			'show-tray': showTray,
			disabled: disabled
		}">
		<button
			class="button -link selections"
			type="button"
			v-tooltip="tooltip"
			disabled
			v-if="disabled">
			{{ label }}
		</button>
		<template v-if="!disabled">
			<button
				class="button -link selections"
				type="button"
				ref="label"
				v-tooltip="tooltip"
				@click="toggleTray">
				{{ label }}
			</button>
			<div
				class="multiselect-options"
				ref="options">
				<label
					v-for="option in options"
					:key="option.text">
					<input
						type="checkbox"
						@click="onOptionToggle(option)"
						:checked="option.selected" />
					<span class="option-text">
						{{ option.text }}
					</span>
				</label>
				<div
					class="load-mask"
					:class="{
						loading: loading
					}"></div>
			</div>
		</template>
	</div>
</template>
